const isProduction = process.env.NODE_ENV === 'production';

function getHost() {
    const { hostname } = window.location;
    return hostname.startsWith('www.') ? hostname.replace('www.', '') : hostname;
}

const isDev = getHost() === 'dev-dattanfse.dattasystem.com.br';

const ENV_CONFIG = {
    development: {
        api: 'https://nfse.dev',
        relatorio: 'http://localhost:8088',
    },
    dev: {
        api: 'https://api-nfse-dev.dattasystem.com.br',
        relatorio: 'https://relatorio-nfse.dattasystem.com.br',
    },
    production: {
        api: 'https://api-nfse.dattasystem.com.br',
        relatorio: 'https://relatorio-nfse.dattasystem.com.br',
    },
};

function getEnvConfig() {
    if (isDev) return ENV_CONFIG.dev;
    if (!isProduction) return ENV_CONFIG.development;
    return ENV_CONFIG.production;
}

const config = getEnvConfig();

export function getAPIbaseURL() {
    return config.api;
}

export function getRelatorioURL() {
    return config.relatorio;
}

export function getSimplesNacionalURL() {
    return 'https://api-simples.dattasystem.com.br';
}

export function getEntidade() {
    return getHost();
}
